export default {
  '1': '合格',
  '2': '不合格',
  '3': '复查合格',
  '4': '复查不合格',
  '5': '待定',
}